export const DOCUMENT_TYPES = {
  DEFAULT: 'default',
  DEAL: 'deal',
  TASK: 'task',
  TEMPLATE: 'template',
  E_SIGN_TEMPLATE: 'eSignTemplate',
};
